import { useMemo } from 'react';

import { getCryptoAccountNumbers } from 'utils/accounts/getCryptoAccountNumbers';

import { useGetCollectionFundingInstructions } from 'api';
import { useOrganisationId } from 'customer_app_client/src/hooks/context';
import { hasValue } from 'customer_app_client/src/utils/hasValue';

import { useCryptoProvider } from './useCryptoProvider';
import { useCryptoWidgetVariant } from './useCryptoWidgetVariant';
import { usePermissions } from './usePermissions';

export const useIsCryptoFundingEnabled = () => {
  const { isPermitted } = usePermissions();
  const organisationId = useOrganisationId<number>();
  const { data: { data: fundingInstructions } = {}, isSuccess } =
    useGetCollectionFundingInstructions(Number(organisationId));

  const { cryptoWidgetVariant } = useCryptoWidgetVariant();
  const { cryptoProvider } = useCryptoProvider();

  const isCryptoFundingEnabled = useMemo(() => {
    if (hasValue(cryptoProvider)) return true;
    if (!isSuccess || !hasValue(fundingInstructions)) return false;
    if (!hasValue(cryptoWidgetVariant)) return false;

    return getCryptoAccountNumbers(fundingInstructions).size > 0;
  }, [fundingInstructions, isSuccess, cryptoProvider, cryptoWidgetVariant]);

  return isPermitted('crypto:manage') && isCryptoFundingEnabled;
};
